import { Component, inject } from '@angular/core';

import { RouterLink } from '@angular/router';
import { ClientTableSessionService } from '@features/client/services/client-table-session-service';
import {
  LucideAngularModule,
  QrCode,
  Utensils,
  Zap,
  Smartphone,
  ArrowRight,
  ScanLine,
  Keyboard,
} from 'lucide-angular';
import { PublicHeaderComponent } from '../../../food-venue/components/public-header/public-header.component';
import { NavigationService } from '@core/services/navigation.service';
import { SweetAlertService } from '@core/services/sweet-alert.service';
import { ContactUsLeadCard } from '../contact-us-lead/contact-us-lead-card';
import { FormsModule } from '@angular/forms';
import { QrProcessingService } from '../../../auth/services/qr-processing-service';
import { CommonModule } from '@angular/common';
import { PublicBillSplitEntryComponent } from '../../../../store-front/components/public-bill-split/components/public-bill-split-entry.component/public-bill-split-entry';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    LucideAngularModule,
    PublicHeaderComponent,
    ContactUsLeadCard,
    FormsModule,
    PublicBillSplitEntryComponent,
  ],
  templateUrl: './home-component.html',
})
export class HomeComponent {
  private clientTableSessionService = inject(ClientTableSessionService);
  private navigation = inject(NavigationService);
  private sweetAlert = inject(SweetAlertService);
  private qrProcessingService = inject(QrProcessingService);

  readonly QrCode = QrCode;
  readonly Utensils = Utensils;
  readonly Zap = Zap;
  readonly Smartphone = Smartphone;
  readonly ArrowRight = ArrowRight;
  readonly ScanLine = ScanLine;
  readonly Keyboard = Keyboard;

  manualTableCode = '';

  hasActiveSession = this.clientTableSessionService.hasActiveSession;

  sessionInfo = this.clientTableSessionService.tableSessionInfo;

  onScanQr() {
    this.navigation.navigateToScanner();
  }

  onManualSubmit() {
    const cleanCode = this.manualTableCode.trim().toLowerCase();
    this.qrProcessingService.processTableRequest({ shortCode: cleanCode });
  }

  onFoodVenues() {
    this.navigation.navigateToFoodVenues();
  }

  async onContactUs() {
    const result = await this.sweetAlert.inputText(
      'Contacto comercial',
      'Dejanos tu número y te llamamos',
      'Ej: 11 2345 6789',
    );

    if (!result) return;
  }

  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
